import styled from 'styled-components';

import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints } from '~/src/constants/breakpoints';

import { Form } from '~/src/features/center/Form/styled';
import { IProps } from '~/src/features/center/StepBlock/styled';

interface IForm {
    isActiveForm: boolean,
}

export const Img = styled.div`
    width: 100%;
    min-height: 170px;
    background-image: url('${(props: IProps) => props.url}');
    background-repeat: no-repeat;
    background-position: bottom;
    background-color: transparent;
    margin-top: -35px;

    @media (max-width: ${breakPoints.desktop}) {
        min-height: 130px;
        background-position: bottom;
        background-size: auto;
    }

    @media (max-width: ${breakPoints.tablet}) {
        height: 250px;
        margin-top: 0;
    }

    @media (max-width: ${breakPoints.mobile}) {
        height: 230px;
    }

    @media (max-width: 520px) {
        background-size: auto;
    }

    @media (max-width: 470px) {
        background-image: url('${(props: IProps) => `${props.mUrl}`}');
        height: 135px;
    }
`;

export const TextWrapper = styled.div`
    display: block;
`;

export const Legal = styled.div`
    position: absolute;
    width: 300px;
    top: ${(props: IForm) => props.isActiveForm ? '70px' : '61px'};
    ${FONTS.XS};
    text-align: center;

    @media (max-width: ${breakPoints.mobile}) {
        top: 105px;
        z-index: ${(props: IForm) => props.isActiveForm ? '-1' : '1'};
    }
`;

export const ContainerButtons = styled.div`
    position: relative;
    justify-content: center;
    margin-top: 16px;
    padding-left: 30px;
    padding-right: 30px;

    & ${Form} p {
        display: none;
    }
`;

export const TitleWrapper = styled.div`
    width: 100%;
    height: auto;
    text-align: center;
    justify-content: center;
    margin-top: 15px;
    ${FONTS.H2};

    @media (max-width: ${breakPoints.desktop}) {
        ${FONTS.H3};
    }

    @media (max-width: ${breakPoints.mobile}) {
        ${FONTS.H3};
        margin-top: 0;
        padding-left: 15px;
        padding-right: 15px;
    }

    @media (max-width: 350px) {
        padding-left: 6px;
        padding-right: 6px;
    }
`;

export const Title = styled.div`
    display: block;
    width: 538px;

    @media (max-width: ${breakPoints.desktop}) {
        width: 425px;
    }

    @media (max-width: ${breakPoints.tablet}) {
        width: 431px;
    }

    @media (max-width: ${breakPoints.mobile}) {
        width: auto;
    }
`;

export const ContainerElement = styled.div`
    display: block;
    width: 100%;
`;

export const Text = styled.div`
    display: block;
    text-align: center;
    ${FONTS.M};
    opacity: .8;
    padding-left: 60px;
    padding-right: 60px;
    margin-top: 8px;

    @media (max-width: ${breakPoints.desktop}) {
        padding-left: 79px;
        padding-right: 79px;
        ${FONTS.S};
    }

    @media (min-width: ${breakPoints.tablet}) and (max-width: 1278px) {
        padding-left: 23px;
        padding-right: 23px;
    }

    @media (max-width: ${breakPoints.mobile}) {
        ${FONTS.XS};
        padding-left: 24px;
        padding-right: 24px;
    }
`;
